/**
 * What ⌘K asks each list for. `№1042` and `1042` are a deal's number, and also what a phone's
 * tail looks like, so digits go to both. A query mostly of digits with phone punctuation goes
 * through the clients' `?phone=` lookup, which normalises it; anything else is a name.
 */
export interface SearchParams {
  clients: Record<string, string>;
  deals: Record<string, string>;
}

const PHONE_SHAPED = /^\+?[\d\s\-()]{5,}$/;

export function searchParamsFor(term: string): SearchParams {
  const withoutNumberSign = term.replace(/^№\s*/, "");
  return {
    clients: PHONE_SHAPED.test(term) ? { phone: term } : { search: withoutNumberSign },
    deals: { search: withoutNumberSign },
  };
}
